<template>
  <div class="dialog_box">
    <el-dialog :title="type == 0 ? '新增用户' : '修改用户'" :visible="show" width="878px" @close="dialogClose" top="10vh"
      :close-on-click-modal="false">
      <div class="dialog_container">
        <el-form ref="form" class="form_box" :model="form" label-width="110px" :rules="rules">
          <div class="module_box">
            <div class="form_title">账号信息</div>
            <el-form-item label="登录手机号" prop="phoneNumber" class="form_location">
              <el-input v-model="form.phoneNumber" placeholder="请输入登录手机号"></el-input>
              <div class="hint">
                使用此手机号作为账号登录后台或者小程序、APP
              </div>
            </el-form-item>

            <el-form-item label="登录密码" prop="password">
              <el-input v-model="form.password" placeholder="请输入登录密码" show-password></el-input>
            </el-form-item>

            <div class="form_title" style="margin-top: 15px">基本信息</div>
            <el-form-item label="真实姓名" prop="username">
              <el-input v-model="form.username" placeholder="请输入真实姓名"></el-input>
            </el-form-item>
            <el-form-item label="用户名" prop="userId">
              <el-input v-model="form.userId" :disabled="type === 0 ? false : true" placeholder="请输入用户名"></el-input>
            </el-form-item>
            <el-form-item label="工号">
              <el-input v-model="form.workNum" placeholder="请输入工号"></el-input>
            </el-form-item>
            <el-form-item label="上级账号" prop="pidArr">
              <el-cascader v-model="form.pidArr" :options="pidList"
                :props="{ value: 'id', label: 'name', checkStrictly: true }" :disabled="type == 0 ? false : true"
                :placeholder="'请选择上级账号'" :show-all-levels="false" @change="handleChange"></el-cascader>
            </el-form-item>
            <el-form-item label="性别">
              <el-radio v-model="form.sex" :label="1">男</el-radio>
              <el-radio v-model="form.sex" :label="0">女</el-radio>
            </el-form-item>
            <el-form-item label="账户类型" prop="userType" class="form_location">
              <el-select v-model="form.userType" :disabled="userTypeDisabled ? true : false" :placeholder="userTypeDisabled ? '请先选择上级账号' : '请选择账户类型'
                ">
                <el-option v-for="item in typeList" :key="item.id" :label="item.name" :value="item.id"></el-option>
              </el-select>
            </el-form-item>
            <el-form-item label="状态" prop="userStatus" class="form_status">
              <el-switch v-model="form.userStatus" :active-value="0" :inactive-value="1" active-color="#7490EB"
                inactive-color="#E7E7E7">
              </el-switch>
            </el-form-item>
            <el-form-item label="企业名称" prop="orgId" v-if="form.userType == '企业'">
              <el-select v-model="form.orgId" filterable placeholder="请输入/选择企业名称" @change="orgChange">
                <el-option v-for="item in orgList" :key="item.id" :label="item.orgName" :value="item.id">
                </el-option>
              </el-select>
            </el-form-item>
            <el-form-item label="邮箱" v-if="form.userType == '企业'">
              <el-input v-model="form.email" placeholder="请输入邮箱"></el-input>
            </el-form-item>

            <el-form-item label="企业信用码" v-if="form.userType == '企业'">
              <el-input v-model="form.creditCode" disabled placeholder="输入/选择企业后自动填充"></el-input>
            </el-form-item>
            <el-form-item label="企业地址" v-if="form.userType == '企业'">
              <el-input v-model="form.addr" disabled placeholder="输入/选择企业后自动填充"></el-input>
            </el-form-item>

            <div class="form_title">角色信息</div>
            <el-form-item label="用户角色" prop="roleList">
              <el-select v-model="form.roleList" placeholder="请选择用户角色">
                <el-option v-for="item in roleList" :key="item.roleId" :label="item.roleName"
                  :value="item.roleId"></el-option>
              </el-select>
            </el-form-item>
          </div>
        </el-form>
      </div>
      <span slot="footer" class="dialog-footer">
        <el-button class="btn" @click="dialogClose">取 消</el-button>
        <el-button class="btn btn_ok" @click="confirm('form')">提 交</el-button>
      </span>
    </el-dialog>
  </div>
</template>

<script>

export default {
  name: "",
  data () {
    return {
      form: {},
      imgUrl: "",
      typeList: [
        {
          name: "企业",
          id: "企业",
        },
        {
          name: "部门主管",
          id: "部门主管",
        },
        {
          name: "个人",
          id: "个人",
        },
      ],
      roleList: [],
      pidList: [],
      tempList: [],
      userType: "",
      userTypeDisabled: true,
      rules: {
        phoneNumber: [
          { required: true, message: "请输入登录手机号", trigger: "blur" },
        ],
        password: [
          { required: true, message: "请输入登录密码", trigger: "blur" },
        ],
        username: [
          { required: true, message: "请输入真实姓名", trigger: "blur" },
        ],
        userId: [{ required: true, message: "请输入用户名", trigger: "blur" }],
        workNum: [{ required: true, message: "请输入工号", trigger: "blur" }],
        pidArr: [{ required: true, message: "请选择上级账号", trigger: "change" }],
        userType: [
          {
            required: true,
            message: "请选择账户类型",
            trigger: ["change", "blur"],
          },
        ],
        userStatus: [
          { required: true, message: "请选择用户状态", trigger: "change" },
        ],
        roleList: [
          { required: true, message: "请选择用户角色", trigger: "change" },
        ],
        orgId: [
          { required: true, message: "请输入/选择企业名称", trigger: ["blur", "change"] },
        ],
        creditCode: [
          { required: true, message: "请输入企业信用码", trigger: "blur" },
        ],
        addr: [
          { required: true, message: "请输入企业地址", trigger: "blur" },
        ],
      },
      orgList: []
    };
  },
  components: {},
  props: {
    show: {
      type: Boolean,
      default: false,
    },
    data: {
      type: Object,
      default: {},
    },
    type: {
      type: Number,
      default: 0,
    },
  },
  watch: {
    show (val) {
      if (val) {
        this.userTypeDisabled = true;
        switch (this.type) {
          case 0:
            this.$set(this.form, "phoneNumber", "");
            this.$set(this.form, "password", "");
            this.$set(this.form, "username", "");
            this.$set(this.form, "userId", "");
            this.$set(this.form, "workNum", "");
            this.$set(this.form, "pid", null);
            this.$set(this.form, "pidArr", null);
            this.$set(this.form, "sex", 2);
            this.$set(this.form, "userType", null);
            this.$set(this.form, "userType", "");
            this.$set(this.form, "userStatus", 0);
            this.$set(this.form, "roleList", null);
            this.$set(this.form, "orgName", "");
            this.$set(this.form, "email", "");
            this.$set(this.form, "creditCode", "");
            this.$set(this.form, "addr", "");
            this.typeList = [];
            break;

          case 1:
            this.$http.queryUser({ userId: this.data.userId }).then((res) => {
              if (res.code === 0) {
                this.$set(this.form, "phoneNumber", res.data.phoneNumber);
                this.$set(this.form, "password", res.data.password);
                this.$set(this.form, "username", res.data.username);
                this.$set(this.form, "userId", res.data.userId);
                this.$set(this.form, "workNum", res.data.workNum);
                this.$set(this.form, "pid", res.data.pid);
                this.$set(this.form, "pidArr", res.data.pid);
                this.$set(this.form, "sex", res.data.sex);
                this.$set(this.form, "userType", res.data.userType);
                this.$set(this.form, "userStatus", res.data.userStatus);
                this.$set(this.form, "roleList", res.data.roleList.length > 0 ? res.data.roleList[0].roleId : '');
                this.$set(this.form, "orgName", res.data.orgName);
                this.$set(this.form, "email", res.data.email);
                this.$set(this.form, "creditCode", res.data.creditCode);
                this.$set(this.form, "addr", res.data.addr);
              }
            });
            break;
        }
        this.$http.queryUserList({
          page: 1,
          limit: 10000000,
          isTree: true,
        }).then((res) => {
          if (res.code === 0) {
            this.pidList = res.data;
          }
        });
        this.$http.queryUserList({
          page: 1,
          limit: 99999999,
          isTree: false,
        }).then((res) => {
          if (res.code === 0) {
            this.tempList = res.data;
          }
        });
        this.$http.queryRoleList({
          page: 1,
          limit: 10000000,
          status: 0
        }).then((res) => {
          if (res.code === 0) {
            this.roleList = res.data;
          }
        });
        this.$http.queryOrgList({ page: 1, limit: 999999 }).then(res => {
          if (res.code === 0) {
            this.orgList = res.data;
          } else {
            this.orgList = [];
          }
        })
      }
    },
  },
  created () { },
  methods: {
    orgChange (e) {
      this.orgList.forEach(i => {
        if (i.id === e) {
          this.form.orgName = i.orgName;
          this.form.addr = i.addr;
          this.form.creditCode = i.creditCode
        }
      })
    },
    dialogClose () {
      this.$emit("update:show", false);
    },
    handleChange (e) {
      this.tempList.forEach((a) => {
        if (e[e.length - 1] == a.userId) {
          this.form.userType = null;
          if (a.userType == "超级管理员") {
            this.typeList = [
              {
                name: "企业",
                id: "企业",
              },
              {
                name: "部门主管",
                id: "部门主管",
              },
              {
                name: "个人",
                id: "个人",
              },
            ];
          } else if (a.userType == "企业") {
            this.typeList = [
              {
                name: "部门主管",
                id: "部门主管",
              },
              {
                name: "个人",
                id: "个人",
              },
            ];
          } else if (a.userType == "部门主管") {
            this.typeList = [
              {
                name: "个人",
                id: "个人",
              },
            ];
          } else if (a.userType == "个人") {
            this.typeList = [];
          }
          this.userTypeDisabled = false;
        }
      });
    },
    confirm (formName) {
      console.log(this.form.userType);
      this.$refs[formName].validate((valid) => {
        if (!valid) return false;
        if (this.type === 0) {
          this.form.pid = this.form.pidArr[this.form.pidArr.length - 1];
          this.$http.addUser(this.form).then((res) => {
            if (res.code === 0) {
              // this.$message.success(res.msg);
              this.$parent.getList();
              this.$parent.getTree();
              this.$emit("update:show", false);
            } else {
              this.$message.error(res.msg);
            }
          });
        } else {
          this.$http.updateUser(this.form).then((res) => {
            if (res.code === 0) {
              this.$parent.getList();
              this.$parent.getTree();
              this.$emit("update:show", false);
            } else {
              this.$message.error(res.msg);
            }
          });
        }
      });
    },
  },
};
</script>

<style lang="less" scoped>
@import "../../../assets/css/dialog";

/deep/.el-form-item__content {
  width: 240px;
}

/deep/.el-dialog__body {
  max-height: 70vh;
  overflow-y: visible !important;
}

.form_location {
  position: relative;

  .hint {
    position: absolute;
    top: 45px;
    left: 0;
    font-size: 12px;
    color: #999;
    white-space: nowrap;
    height: 0;
  }
}

// /deep/.el-form-item__error {
//   top: 90%;
// }
</style>



// WEBPACK FOOTER //
// src/views/user_Admin/component/addRedactUserAdmin.vue